import { render, staticRenderFns } from "./AddQualityComment.vue?vue&type=template&id=9807ff60"
import script from "./AddQualityComment.vue?vue&type=script&lang=js"
export * from "./AddQualityComment.vue?vue&type=script&lang=js"
import style0 from "./AddQualityComment.vue?vue&type=style&index=0&id=9807ff60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports